import { isProfileNoNikeone } from '../../profiles';

export function getNikeoneService() {
    return window.OPTIONS.properties
        ? window.OPTIONS.properties['nikeone.service_endpoint']
        : window.OPTIONS['nikeone']['server'];
}

export const isNikeoneEnabled = !isProfileNoNikeone();
